module.exports = __webpack_public_path__ + "img/1.1685c121.png";